import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    portalBriefTokensList: build.query<
      PortalBriefTokensListApiResponse,
      PortalBriefTokensListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    portalBriefTokensCreate: build.mutation<
      PortalBriefTokensCreateApiResponse,
      PortalBriefTokensCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/`,
        method: "POST",
        body: queryArg.portalBriefToken,
      }),
    }),
    portalBriefTokensRetrieve: build.query<
      PortalBriefTokensRetrieveApiResponse,
      PortalBriefTokensRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/`,
      }),
    }),
    portalBriefTokensUpdate: build.mutation<
      PortalBriefTokensUpdateApiResponse,
      PortalBriefTokensUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.portalBriefToken,
      }),
    }),
    portalBriefTokensPartialUpdate: build.mutation<
      PortalBriefTokensPartialUpdateApiResponse,
      PortalBriefTokensPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedPortalBriefToken,
      }),
    }),
    portalBriefTokensDestroy: build.mutation<
      PortalBriefTokensDestroyApiResponse,
      PortalBriefTokensDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1BriefTokensHardDeleteCreate: build.mutation<
      ApiPortalV1BriefTokensHardDeleteCreateApiResponse,
      ApiPortalV1BriefTokensHardDeleteCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/hard_delete/`,
        method: "POST",
        body: queryArg.portalBriefToken,
      }),
    }),
    apiPortalV1BriefTokensRestoreCreate: build.mutation<
      ApiPortalV1BriefTokensRestoreCreateApiResponse,
      ApiPortalV1BriefTokensRestoreCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/brief-tokens/${queryArg.id}/restore/`,
        method: "POST",
        body: queryArg.portalBriefToken,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type PortalBriefTokensListApiResponse =
  /** status 200  */ PaginatedPortalBriefTokenListRead;
export type PortalBriefTokensListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type PortalBriefTokensCreateApiResponse =
  /** status 201  */ PortalBriefTokenRead;
export type PortalBriefTokensCreateApiArg = {
  portalBriefToken: PortalBriefTokenWrite;
};
export type PortalBriefTokensRetrieveApiResponse =
  /** status 200  */ PortalBriefTokenRead;
export type PortalBriefTokensRetrieveApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
};
export type PortalBriefTokensUpdateApiResponse =
  /** status 200  */ PortalBriefTokenRead;
export type PortalBriefTokensUpdateApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
  portalBriefToken: PortalBriefTokenWrite;
};
export type PortalBriefTokensPartialUpdateApiResponse =
  /** status 200  */ PortalBriefTokenRead;
export type PortalBriefTokensPartialUpdateApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
  patchedPortalBriefToken: PatchedPortalBriefTokenWrite;
};
export type PortalBriefTokensDestroyApiResponse = unknown;
export type PortalBriefTokensDestroyApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
};
export type ApiPortalV1BriefTokensHardDeleteCreateApiResponse =
  /** status 200  */ PortalBriefTokenRead;
export type ApiPortalV1BriefTokensHardDeleteCreateApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
  portalBriefToken: PortalBriefTokenWrite;
};
export type ApiPortalV1BriefTokensRestoreCreateApiResponse =
  /** status 200  */ PortalBriefTokenRead;
export type ApiPortalV1BriefTokensRestoreCreateApiArg = {
  /** A unique integer value identifying this brief token. */
  id: number;
  portalBriefToken: PortalBriefTokenWrite;
};
export type TokenTypeEnum = 1 | 2;
export type SurveyStatus68DEnum = 0 | 1 | 2 | 3 | 5 | 6 | 7 | 9 | 100;
export type PortalBriefToken = {
  token_type?: TokenTypeEnum;
  survey_status?: SurveyStatus68DEnum;
  valid_upto?: string | null;
  scheduled_at?: string | null;
  to_delete?: boolean;
};
export type PortalBriefTokenRead = {
  id: number;
  employee: number | null;
  debrief_schedule: number | null;
  employee_email: string;
  employee_name: string;
  debrief_schedule_name: string;
  token: string;
  token_type?: TokenTypeEnum;
  token_type_display: string;
  survey_status?: SurveyStatus68DEnum;
  survey_status_display: string;
  sent: string | null;
  valid_upto?: string | null;
  reminded: number;
  delivery_status: string | null;
  failed: boolean;
  scheduled_at?: string | null;
  to_delete?: boolean;
  deleted_on: string | null;
  created_at: string;
  updated_at: string;
};
export type PortalBriefTokenWrite = {
  employee_id: number;
  debrief_schedule_id: number;
  token_type?: TokenTypeEnum;
  survey_status?: SurveyStatus68DEnum;
  valid_upto?: string | null;
  scheduled_at?: string | null;
  to_delete?: boolean;
};
export type PaginatedPortalBriefTokenList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PortalBriefToken[];
};
export type PaginatedPortalBriefTokenListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PortalBriefTokenRead[];
};
export type PaginatedPortalBriefTokenListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PortalBriefTokenWrite[];
};
export type PatchedPortalBriefToken = {
  token_type?: TokenTypeEnum;
  survey_status?: SurveyStatus68DEnum;
  valid_upto?: string | null;
  scheduled_at?: string | null;
  to_delete?: boolean;
};
export type PatchedPortalBriefTokenRead = {
  id?: number;
  employee?: number | null;
  debrief_schedule?: number | null;
  employee_email?: string;
  employee_name?: string;
  debrief_schedule_name?: string;
  token?: string;
  token_type?: TokenTypeEnum;
  token_type_display?: string;
  survey_status?: SurveyStatus68DEnum;
  survey_status_display?: string;
  sent?: string | null;
  valid_upto?: string | null;
  reminded?: number;
  delivery_status?: string | null;
  failed?: boolean;
  scheduled_at?: string | null;
  to_delete?: boolean;
  deleted_on?: string | null;
  created_at?: string;
  updated_at?: string;
};
export type PatchedPortalBriefTokenWrite = {
  employee_id?: number;
  debrief_schedule_id?: number;
  token_type?: TokenTypeEnum;
  survey_status?: SurveyStatus68DEnum;
  valid_upto?: string | null;
  scheduled_at?: string | null;
  to_delete?: boolean;
};
export const {
  usePortalBriefTokensListQuery,
  usePortalBriefTokensCreateMutation,
  usePortalBriefTokensRetrieveQuery,
  usePortalBriefTokensUpdateMutation,
  usePortalBriefTokensPartialUpdateMutation,
  usePortalBriefTokensDestroyMutation,
  useApiPortalV1BriefTokensHardDeleteCreateMutation,
  useApiPortalV1BriefTokensRestoreCreateMutation,
} = injectedRtkApi;
